<template lang="pug" functional>
.mapping-item {{ props.item.label }} #[i.el-icon-right] {{ props.item.field | field(props.dicts) }}
</template>
<script>
export default {
  functional: true,
  filters: {
    field(value, dict = []) {
      return (dict.find(({ columnName }) => columnName === value) || {}).columnDisplayName;
    }
  }
};
</script>
<style lang="scss" scoped>
.mapping-item {
  border-radius: 2px;
  line-height: 1;
  padding: 7px 4px;
  margin: 0 4px 4px 0;
  display: inline-block;
  background-color: #f5f8fa;
  border: 1px solid #c4cce5;
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
}
</style>
